// CPH parking products and walk times.
//
// Source: cph.dk/parkering-transport/priser-produkter/{direct,standardplus,standard,budget}
//
// No prices live here. CPH prices parking dynamically, so a hand-maintained
// "fra" price is wrong most of the time and a verified-on date does not fix
// that. Walk times and the lot-to-product mapping are stable, so those stay.

// One place to change when the affiliate link lands.
export const BOOKING_URL = 'https://www.cph.dk/parkering-transport';

export const TIERS = {
    direct: {
        label: 'Direct',
        walk: '1-4 min'
    },
    standardplus: {
        label: 'Standard+',
        walk: '3-10 min'
    },
    standard: {
        label: 'Standard',
        walk: '5-15 min'
    },
    budget: {
        label: 'Budget',
        // 1.5-2 km out, free terminal bus around the clock.
        walk: 'bus'
    }
};

// Which entry in CPH's parking feed actually holds each lot's free-space count.
//
// This mapping exists because the obvious-looking field is the wrong one.
// `<lot> Garanti` is the guaranteed PRE-BOOKED allocation, not availability:
// it goes deeply negative once bookings exceed the reserved block, so P1
// reported -1274 while the lot genuinely had 1043 free spaces. Five lots
// (P1, P12, P17, P19, P4H) never returned a positive Garanti value in 51,876
// readings over six months, which is why they used to render permanently FULL.
//
// The naming is not uniform, so no generic filter works. Verified 2026-07-30
// against the per-level counts in the same payload (P6: 10+83=93,
// P8: 47+137=184, P3 levels sum to 169 vs 168 reported).
export const FEED_TITLE = {
    P1: 'P1 - Total',
    P3: 'P3',
    P4: 'P4 total',
    // P4-0 only ever appears as "P4-0 total Garanti"; there is no free-space
    // series for it, so it renders as "no live data" rather than as FULL.
    'P4-0': null,
    P4H: 'P4H total',
    P5: 'P5 total',
    P6: 'P6 level -1 + -2 Total',
    P7A: 'P7A total',
    P7B: 'P7B total',
    P8: 'P8 L-1 + L-2 Total',
    P9: 'P9 total',
    P10: 'P10 total',
    P11: 'P11 total',
    P12: 'P12 total',
    P15: 'P15 total',
    P17: 'P17 total',
    P19: 'P19 total'
};

// Highest free count observed per lot over 12 months, used only to scale the
// fill bar. A proxy for capacity, not published capacity: a lot is rarely
// completely empty, so true capacity is somewhat higher. Never shown as a
// number, only used to size the bar.
export const REFERENCE_FREE = {
    P1: 1861,
    P3: 427,
    P4: 735,
    P4H: 15,
    P5: 86,
    P6: 243,
    P7A: 209,
    P7B: 472,
    P8: 506,
    P9: 163,
    P10: 562,
    P11: 532,
    P12: 736,
    P15: 1319,
    P17: 621,
    P19: 425
};

// Lot -> tier. Keys match the first token of the `title` the CPH feed gives us
// (P4-0, P4H and P7A are drive-up/short-stay areas CPH sells no online product
// for, so they stay unmapped and simply render without tier info).
const LOT_TIERS = {
    P4: 'direct',
    P6: 'direct',
    P7B: 'direct',
    P8: 'direct',
    P3: 'standardplus',
    P5: 'standardplus',
    P9: 'standardplus',
    P10: 'standardplus',
    P1: 'standard',
    P11: 'standard',
    P12: 'standard',
    P15: 'budget',
    P17: 'budget',
    P19: 'budget'
};

export function tierForLot(lotTitle) {
    if (!lotTitle) return null;
    const key = String(lotTitle).split(' ')[0].toUpperCase();
    const tier = LOT_TIERS[key];
    return tier ? { id: tier, ...TIERS[tier] } : null;
}
